import React from 'react';
import './Clients.css';

const clients = [
  { name: 'Aeromexico', logo: '/clients/Aeromexico.png', alt: 'Aeromexico Logo' },
  { name: 'Google', logo: '/clients/google.png', alt: 'Google Logo' },
  { name: 'United Airlines', logo: '/clients/unitedairlines.png', alt: 'United Airlines Logo' },
  { name: 'Walmart', logo: '/clients/walmart.svg', alt: 'Walmart Logo' },
  { name: "L'Oréal", logo: '/clients/loreal.svg', alt: "L'Oréal Logo" },
  { name: 'KPMG', logo: '/clients/kpmg.svg', alt: 'KPMG Logo' },
  { name: 'Scotiabank', logo: '/clients/scotiabank.svg', alt: 'Scotiabank Logo' },
  { name: 'BMW', logo: '/clients/bmw.svg', alt: 'BMW Logo' },
  { name: 'General Motors', logo: '/clients/gm.svg', alt: 'General Motors Logo' },
  { name: 'Honeywell', logo: '/clients/honeywell.svg', alt: 'Honeywell Logo' },
];

const Clients = () => {
  const track = [...clients, ...clients];

  return (
    <section className="clients-section">
      <div className="container">
        <div className="clients-header">
          <h3>Trusted by Leading Companies</h3>
          <p>Solutions developed by our team have been implemented by leading organizations</p>
        </div>
      </div>
      <div className="clients-carousel" aria-label="Client logos">
        <div className="clients-track">
          {track.map((client, index) => (
            <div
              key={`${client.name}-${index}`}
              className="client-logo"
              aria-hidden={index >= clients.length}
            >
              <img
                src={client.logo}
                alt={index >= clients.length ? '' : client.alt}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="client-fallback" style={{ display: 'none' }}>
                <span>{client.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
